var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-4"},[_c('h4',{staticClass:"settings-h4"},[_vm._v("Awaiting Files")]),_c('div',{staticClass:"wrapper-1 pa-2"},[_c('FileLifeTime',{attrs:{"kioskSettings":_vm.kioskSettings}}),_c('AlertBeforeDelete',{attrs:{"kioskSettings":_vm.kioskSettings}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }